import axios from 'axios';

// Determine the base URL based on the environment
const isProduction = process.env.NODE_ENV === 'production';
const baseURL = isProduction
  ? 'https://thornsdashboard.com/api'
  : 'http://localhost:3002/api';

console.log(`API baseURL set to: ${baseURL}`);

const api = axios.create({
  baseURL,
  timeout: 120000,
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      console.log('Request sent with token:', token.substring(0, 10) + '...');
    }
    return config;
  },
  (error) => {
    console.error('Request error:', error);
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    console.log('Response received:', response.status, response.config.url, {
      data: response.data,
      headers: response.headers,
    });
    const newToken = response.headers['x-new-token'];
    if (newToken) {
      localStorage.setItem('token', newToken);
      console.log('New token received and stored:', newToken.substring(0, 10) + '...');
    }
    return response;
  },
  async (error) => {
    const originalRequest = error.config;
    if (error.response) {
      console.error('Response error:', error.response.status, error.response.config.url, {
        data: error.response.data,
        headers: error.response.headers,
      });
      if (error.response.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;
        console.log('401 Unauthorized detected, handling...');
        const newToken = localStorage.getItem('token');
        if (newToken && newToken !== originalRequest.headers.Authorization?.split(' ')[1]) {
          console.log('Using updated token from storage:', newToken.substring(0, 10) + '...');
          originalRequest.headers.Authorization = `Bearer ${newToken}`;
          return api(originalRequest);
        }
        const refreshToken = localStorage.getItem('refreshToken');
        if (!refreshToken) {
          console.warn('No refresh token available, redirecting to login');
          localStorage.removeItem('token');
          localStorage.removeItem('refreshToken');
          window.location.href = '/login';
          return Promise.reject(error);
        }
        try {
          const refreshResponse = await axios.post(
            `${baseURL}/refresh`,
            { refreshToken },
            { headers: { 'Content-Type': 'application/json' } }
          );
          const newToken = refreshResponse.data.token;
          localStorage.setItem('token', newToken);
          console.log('Token refreshed via endpoint, new token:', newToken.substring(0, 10) + '...');
          originalRequest.headers.Authorization = `Bearer ${newToken}`;
          return api(originalRequest);
        } catch (refreshError) {
          console.error('Refresh failed:', refreshError.response?.data || refreshError.message);
          localStorage.removeItem('token');
          localStorage.removeItem('refreshToken');
          window.location.href = '/login';
          return Promise.reject(refreshError);
        }
      }
      if (error.response.status === 401 && error.response.data.error === 'Token expired. Please login again.') {
        console.warn('Server indicates no refresh token, redirecting to login');
        localStorage.removeItem('token');
        localStorage.removeItem('refreshToken');
        window.location.href = '/login';
        return Promise.reject(error);
      }
    } else {
      console.error('Network or unexpected error:', error.message);
    }
    return Promise.reject(error);
  }
);

export default api;